export const REGISTER_FILL = 'SLOT_AND_FILL_REGISTER_FILL';

export const REMOVE_FILLED_COMPONENT = 'SLOT_AND_FILL_REMOVE_FILLED_COMPONENT';
